<template>
  <grid-component
    isResizable
    isReorderable
    isSortable
    :canEdit="checkClaim(CAN_EDIT_VENDOR_RETURNS)"
    :canDelete="checkClaim(CAN_DELETE_VENDOR_RETURNS)"
    :gridId="gridId"
    :itemData="itemData"
    :pageSizes="pageInfo.pageSize"
    :totalItems="pageInfo.totalItems"
    :fields="fields"
    :handleRowClick="onRowClick"
    :sortBy="gridInfo.sortBy"
    :sortOrder="gridInfo.sortOrder"
    :sortMethod="onSort"
    :onEdit="pushToDetails"
  />
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import vendorrmasFields from '@/pages/Vendorrmas/fields';
  import { GRID_ID } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';

  export default {
    components: {
      GridSettings,
      GridComponent,
    },
    name: 'VendorRMATabGrid',
    props: {
      companyId: {
        type: [String, Number],
        default: 0,
      },
      partId: {
        type: [String, Number],
        default: 0,
      },
      partNumber: {
        type: String,
        default: null,
      },
      rmaLineId: {
        type: [String, Number],
        default: 0,
      },
      isParentList:{
        type: Boolean,
        default: false,
      },
      vendorRmaParentList:{
        type: Array,
        default: () => [],
      },
      gridId:{
        type: String,
        default: GRID_ID.VENDORRMAS,
      }
    },
    data: () => ({
      fields: vendorrmasFields,
      // gridId: GRID_ID.VENDORRMAS,
      selectedRowItemId: 0,
    }),
    computed: {
      ...mapGetters('vendorrmas', ['pageInfo', 'vrmasListByCompany', 'vrmasListByPart', 'vrmasListByRmaLine']),
      ...mapGetters('account', ['gridSettingsById']),
      ...mapGetters('shippingReceiving', ['vrmaPageInfo']),
      itemData() {
        const vrmaListType = (this.isParentList) ? this.vendorRmaParentList : (this.companyId) ? this.vrmasListByCompany
          : (this.partId) ? this.vrmasListByPart
          : (this.rmaLineId) ? this.vrmasListByRmaLine : [];
        if (vrmaListType == undefined || !vrmaListType.length) return [];
        return vrmaListType.map((vrma) => ({ ...vrma, selected: vrma.id === this.selectedRowItemId }));
      },
      gridSettings() {
        return this.gridSettingsById(GRID_ID.REQUIREMENT);
      },
      gridInfo() {
        return this.isParentList ? this.vrmaPageInfo : {sortBy: null, sortOrder: null}
      }
    },
    methods: {
      ...mapActions('vendorrmas', ['getVendorRMAByCompany', 'getVendorRMAByPart', 'getVendorRMAByRmaLine']),
      onSort($e) {
      if (this.isParentList) {
        this.$emit('onSort', $e)
      }
    },
      onRowClick(row) {
        this.selectedRowItemId = row.dataItem.id;
        this.$emit('selectedSourceObj', row.dataItem);
      },
      pushToDetails(row) {
        this.$router.push({
          name: 'vendorrmas.edit',
          params: { id: row.id },
        });
      },
      getVendorRMAsList() {
        if (this.companyId) {
          this.getVendorRMAByCompany(this.companyId);
        } else if (this.partId) {
          this.getVendorRMAByPart(this.partId);
        } else if (this.rmaLineId) {
          this.getVendorRMAByRmaLine(this.rmaLineId);
        }
      },
    },
    watch: {
      partId() {
        this.getVendorRMAsList();
      },
      companyId() {
        this.getVendorRMAsList();
      },
      rmaLineId() {
        this.getVendorRMAsList();
      }
    },
  };
</script>
